import { getStoreKey } from "@utils/detail";

export default function store(state) {
    const storeKey = getStoreKey(state.bundle.id); //Unuseful for collection... Example id: 6340, then get is for 271
    const {
        bundle,
        loading,
        cartLoading,
        sizesPopup,
        sliderGallery,
        preview,
        ...rest
    } = state

    sessionStorage.setItem(storeKey, JSON.stringify({
        ...rest,
        step: {
            index: state.step?.index || 0,
            configured: state.step?.configured || 0,
        }
    }));
}